/**
 * Created by Kieran on 17/08/2017.
 */

let HTMLStringParser = {
  /**
   * String to uppercase
   * @param string
   * @returns {*}
   */
  toUpper(string) {
    return string.toLowerCase();
  },
  /**
   * String to lower case
   * @param string
   * @returns {*}
   */
  toLower(string) {
    return string.toLowerCase();
  },
  /**
   * Remove &amp; just renders as it should '&'
   * @param title
   * @returns {string|*}
   */
  encode(title) {
    let encodedStr = title;
    let parser = new DOMParser;
    let dom = parser.parseFromString(
      '<!doctype html><body>' + encodedStr,
      'text/html');
    title = dom.body.textContent;
    return title;
  }
};
export default HTMLStringParser;



// WEBPACK FOOTER //
// ./src/helpers/HTMLStringParser/index.js